import { IPlatformItem } from '@/axios/common';
import { useStore } from '@/stores';
import { useControllableValue } from 'ahooks';
import { Checkbox, Flex, Form } from 'antd';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import doubaoImg from '@/assets/platform/doubao.png';
const FlexBox = styled(Flex)`
  min-width: 150px;
  padding: 16px 8px;
  cursor: pointer;
  border-radius: 6px;
  background: #f7f8fa;
  border: 1px solid transparent;
  &.selected {
    border: 1px solid #fa8846;
    background: #fff2eb;
  }
  img {
    width: 24px;
  }
`;

const CustomCheckbox = ({
  item,
  checked,
  onChange,
}: {
  item: IPlatformItem;
  checked?: boolean;
  onChange?: () => void;
}) => {
  return (
    <FlexBox gap={8} justify="space-between" className={checked ? 'selected' : ''} onClick={() => {
      onChange?.()
    }}>
      <Flex gap={8}>
        {/* <img src={doubaoImg} alt={item.name} /> */}
        {item.name}
      </Flex>
      <Checkbox checked={checked} onChange={onChange} onClick={(e) => {
        e.stopPropagation()
      }} />
    </FlexBox>
  );
};
const CustomCheckboxFormItem = ({
  platformListData,
  value,
  onChange,
}:
{
  value?: string[];
  onChange?: (value: string[]) => void;
  platformListData?: IPlatformItem[];
}) => {
  const [selected, onSelectedChange] = useControllableValue<string[]>({
    value: value,
    onChange: onChange,
  });
  return (
    <Flex gap={8} wrap>
      {platformListData?.map((item) => {
        return (
          <CustomCheckbox
            item={item}
            key={item.platform}
            checked={selected?.includes(item.platform)}
            onChange={() => {
              const newValue = selected?.includes(item.platform)
                ? selected.filter((v) => v !== item.platform)
                : [...(selected || []), item.platform];
              onSelectedChange?.(newValue);
            }}
          />
        );
      })}
    </Flex>
  );
};
const PlatFormItem = ({
  name = 'platforms',
  label = '平台',
  platformList = [],
}: {
  name?: string;
  label?: string;
  platformList?: IPlatformItem[];
}) => {
  const platformListData = platformList;
  return (
    <Form.Item
      name={name}
      label={label}
      rules={[{ required: true, message: `请选择${label}` }]}
      initialValue={platformListData.filter((item) => item.defaultCheck).map((item) => item.platform)}
    >
      <CustomCheckboxFormItem platformListData={platformListData} />
      {/* <Checkbox.Group
        options={platformListData.map((item) => ({
          label: <CustomLabel item={item} />,
          value: item.platform,
        }))}
      /> */}
    </Form.Item>
  );
};
export default observer(PlatFormItem);
